import Flickity from "flickity";

export default () => {
    const carousel = document.querySelector("[data-hero-carousel]");

    const initPopups = () => {
        const slides = document.querySelectorAll('[data-popups]');
        for (const slide of slides) {
            let holder = slide.querySelector('.popup-container');
            if (!holder) {
                holder = document.createElement('DIV');
                holder.classList.add('popup-container');
                slide.append(holder);
            }

            const data = JSON.parse(slide.getAttribute('data-popups'));
            const rect = slide.getBoundingClientRect();
            const cW = rect.width;
            const cH = rect.height;
            const cR = (cH/cW);

            const iW = 1900;
            const iH = 800;
            const iR = (iH/iW);

            let rW = 0;
            let rH = 0;

            if (cR > iR) {
                rH = cH;
                rW = cH / iR;
            } else {
                rW = cW;
                rH = cW / iR;
            }



            for (const dot of data) {
                let dX = dot.x * rW / 1900;
                let dY = dot.y * rH / 800;


                if (rW > cW) {
                    dX = dX - ((rW - cW) / 2);
                }
                if (rH > cH) {
                    dY = dY - ((rH - cH) / 2);
                }

                const query = `point-${dot.id}`;
                let dom = document.querySelector(`#${query}`);

                if (!dom) {
                    dom = document.createElement('div');
                    dom.classList.add('popup-dot');
                    dom.id = query;
                    dom.addEventListener('click', () => {
                        if (dom.classList.contains('active')) {
                            dom.classList.remove('active');
                        } else {
                            dom.classList.add('active');
                        }
                    });
                    dom.innerHTML = `<span class="popup-dot__sort">${dot.sort}</span><div class="popup-main">
    <div class="popup-main__inner">
        <div class="popup-main__inner__close">
            <span>x</span>
        </div>
        <h3>${dot.title}</h3>
        <div>
            <p>${dot.content}</p>
        </div>
    </div>
</div>`;

                    holder.append(dom);
                }

                dom.style.top = dY + 'px';
                dom.style.left = dX + 'px';


            }


        }
    }

    if (carousel) {
        if (carousel.childNodes.length > 1) {
            const flickity = new Flickity(carousel, {
                // options
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                autoPlay: 5000,
                pauseAutoPlayOnHover: false,
                friction: 0.4,
                selectedAttraction: 0.012
            });

            // Keep autoplay on user interaction
            flickity.off('uiChange', flickity.stopPlayer);
            flickity.off('pointerDown', flickity.stopPlayer);

            initPopups();

            window.addEventListener('resize', () => {
                initPopups();
            })

        }
    }
};
